// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { FormEffects } from './store/effects';
import * as fromForm from './store/reducer';

// SERVICES
import { FormStoreService } from './form-store.service';
import { FormService } from './services/form.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['form'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure form ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 28-05-2020 Form store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('form', fromForm.reducer, { metaReducers }),
    EffectsModule.forFeature([FormEffects]),
  ],
  declarations: [],
  providers: [
    FormService,
    FormStoreService,
  ],
})
export class FormStoreModule { }
